import React, { useEffect, useState } from "react";
import {
  CMFooterContainer,
  CMFooterCopyRight,
  CMFooter,
} from "./footer.styles";
import Socialmedia from "../../components/social-media/social-media.component";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../Contexts/auth.context";
import TermsModal from "../terms-modal/terms-modal.component";
import TradeModal from "../trade-modal/trade-modal.component";
import { getPairList } from "../../Services/trading-board.service";

const Footer = () => {
  const {auth} = useAuth();
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const [openTerms, setOpenTerms] = useState(false);
  const [isMyListingsVisible, setIsMyListingsVisible] = useState(false);
  const handleCloseTerms = () => {
    setOpenTerms(false);
  }
  const handleOpenTerms = () => setOpenTerms(true);
  const [openTrade, setOpenTrade] = useState(false);
  const handleCloseTrade = () => {
    setOpenTrade(false);
  }
  const handleOpenTrade = () => {
    if(process.env.REACT_APP_ENVIRONMENT === 'app') {
      getPairList().then(response => {
        if(response?.data?.pairList && response?.data?.pairList.length != 0) {
          navigate("/trading-board");
        }
        else {
          setOpenTrade(true);
        }
      });
    }
    else {
      setTimeout(() => {
        navigate("/trading-board");
      }, 1000);
    }
  }

  useEffect(() => {
    if (auth && auth.user_accounttype) {
      if (auth.user_accounttype === "Trader") {
        setIsMyListingsVisible(false);
      } else {
        setIsMyListingsVisible(true);
      }
    }
  }, [])

  return (
    <footer>
      <CMFooter>
        <CMFooterContainer>
          <div className="smallColumn ">
            {auth && auth.userId ? (
              <div>
                <div>
                  <Link to="/auctions-board">Auctions board</Link>
                </div>
                <div>
                  <Link to="#" onClick={handleOpenTrade}>Trading board</Link>
                </div>
                <div>
                  <Link to="/portfolio">My portfolio</Link>
                </div>
                {auth.user_accounttype !== "Trader" && 
                <div>
                  <Link to="/dashboard">My Listings</Link>
                </div>
                }
              </div>
            
            ) 
            
            : (
            <div></div>
            )}       
          </div>
          
        
    <div className={ auth ? 'rightColumn' : 'largeColumn' }>
        {auth && auth.userId ? (
          <div className="smallColumn">
            <div><Link to="/contact-us" onClick={scrollToTop}>Contact us</Link></div>
            <div><Link to="/support-center" onClick={scrollToTop}>Support & FAQS.</Link></div>
            {/* <div><Link to="/latest-news" onClick={scrollToTop}>Latest news</Link></div> */}
            {/*<div><Link to="/FAQs" onClick={scrollToTop}>FAQs</Link></div>*/}
            <div><Link to="/privacy-policy" onClick={scrollToTop}>Privacy Policy</Link></div>
            <div><Link to="/disclaimer" onClick={scrollToTop}>Disclaimer</Link></div>
            <div><Link to="#" onClick={handleOpenTerms}>Terms and Conditions</Link></div>
          </div>        
          ) 
          : (
           <div>
              <div><Link to="https://musicbull.com/contact-us/" onClick={scrollToTop} target="_blank">Contact us</Link></div>
              {/* <div><Link to="/support-center" onClick={scrollToTop}>Support & FAQS</Link></div> */}
              {/* <div><Link to="/latest-news" onClick={scrollToTop}>Latest news</Link></div> 
              <div><Link to="/FAQs" onClick={scrollToTop}>FAQs</Link></div>*/}
              <div><Link to="/privacy-policy" onClick={scrollToTop}>Privacy Policy</Link></div>
              <div><Link to="/disclaimer"onClick={scrollToTop}>Disclaimer</Link></div>
              <div><Link to="#" onClick={handleOpenTerms}>Terms and Conditions</Link></div>
              <div><Link to="/login" onClick={scrollToTop}>Login</Link></div>
          </div>
          )}   
          </div>
          <div className="rightColumn">
            <Socialmedia footer={1} style={{ fill: "#fff" }} hide={{ display: "none" }} />
          </div>
        </CMFooterContainer>
        <CMFooterCopyRight>
          Copyright &copy; { currentYear } Music bull. All rights reserved.
        </CMFooterCopyRight>
      </CMFooter>
      <TermsModal open={openTerms} onClose={() => handleCloseTerms()}/>
      <TradeModal open={openTrade} onClose={() => handleCloseTrade()} />
    </footer>
  );
};

export default Footer;
